export const createClassContext = {
    title: 'Create Your Dataset in Real-Time',
    subTitle:
        'Creating a dataset has never been easier! Our platform allows you to snap pictures using your own camera and label them on the spot. It is a great feature for anyone who is looking to build a dataset in real-time scenarios.',
    stepStatus: 'Step 1 of 4'
};

export const setupParametersContext = {
    title: 'Model Configuration and Data Augmentation',
    subTitle:
        "This section allows you to make your model and dataset work better together. You can change the settings of the model such as the learning rate and the number of times the model will go through the dataset.\n\nYou can also use tools like rotation, flipping and scaling to improve the diversity of the dataset and prevent overfitting. With ClassifyAI's user-friendly interface, it's easy to adjust your model and dataset to achieve your desired level of accuracy.",
    stepStatus: 'Step 2 of 4'
};

export const trainContext = {
    title: 'Train and Evaluate',
    subTitle:
        'In this section, you can start training your model using the dataset and configuration you have set up. You can also view the training progress, evaluation metrics such as accuracy and loss, and other results in an easy-to-understand format.',
    stepStatus: 'Step 3 of 4'
};

export const predictContext = {
    title: 'Start to Predict by Using Your Own Model',
    subTitle:
        'In this section you are able to test your trained model by providing an image through your webcam. Just click the button and your model will classify the image and show the result.',
    stepStatus: 'Step 4 of 4'
};
